import { useEffect, useRef } from 'react';
import { useTour } from '@reactour/tour';
import { getActiveTourKey } from './activeTour';
import { MANAGE_SITES_STEP } from './tourRegistry';

// Action-driven gates for the CANpark Manage Sites tour. This hook runs inside
// CANparkAdmin — i.e. only once we're on /canpark-admin — so its presence is the
// signal that the user navigated here. It advances the two gate steps:
//   MENU     -> COMPANY  (arrived on the Manage Sites page)
//   ADD_SITE -> NAME     (the new-site drawer just opened)
// The remaining steps are Next-driven inside the open drawer.
export const useManageSitesTourSync = (drawerOpen: boolean) => {
	const { isOpen, currentStep, setCurrentStep } = useTour();
	const prevDrawerOpenRef = useRef(drawerOpen);

	useEffect(() => {
		const drawerJustClosed = prevDrawerOpenRef.current && !drawerOpen;
		prevDrawerOpenRef.current = drawerOpen;

		if (!isOpen || getActiveTourKey() !== 'canpark_manage_sites') return;

		if (currentStep === MANAGE_SITES_STEP.MANAGE_SITES_ITEM) {
			setCurrentStep(MANAGE_SITES_STEP.COMPANY);
		} else if (
			currentStep === MANAGE_SITES_STEP.ADD_SITE &&
			drawerOpen
		) {
			setCurrentStep(MANAGE_SITES_STEP.NAME);
		} else if (
			currentStep === MANAGE_SITES_STEP.CREATE &&
			drawerJustClosed
		) {
			// Sandboxed create closed the drawer — finish the tour.
			setCurrentStep(MANAGE_SITES_STEP.FINISH);
		}
	}, [isOpen, currentStep, drawerOpen, setCurrentStep]);
};
